export default __webpack_public_path__ + "static/login-bg-43ba0e7ecf9cf6efb7bf0cdd96149d07.png";